module.exports = __webpack_public_path__ + "media/audio.72105805.mp3";